module.exports = __webpack_public_path__ + "img/map-food-active.f6ca9db3.png";